import { ReactNode } from 'react';
import LoadIndicator from '../load-indicator/LoadIndicator.tsx';
import EmptyState from './EmptyState.tsx';
import { EmptyStateProps, LoadingState } from './EmptyStateProps.ts';

type LoadAndEmptyStatesWrapperProps = {
	loadingState: LoadingState;
	networkErrorConfig: EmptyStateProps;
	retryCallback: () => void;
	isNoResult?: boolean;
	noResultConfig?: EmptyStateProps;
	noResultCallback?: () => void;
	children: ReactNode;
	focused?: boolean;
};

/*
A wrapper component that displays different loading states (loading spinner, network error with retry button) and if there is no result.
 */
const LoadAndEmptyStatesWrapper: React.FC<LoadAndEmptyStatesWrapperProps> = ({
	loadingState,
	networkErrorConfig,
	retryCallback,
	isNoResult,
	noResultConfig,
	noResultCallback,
	children,
	focused,
}) => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	networkErrorConfig.callToAction.ctaCallback = retryCallback;

	if (noResultConfig?.callToAction && noResultCallback) {
		noResultConfig.callToAction.ctaCallback = noResultCallback;
	}

	return (
		<>
			{/*If everything is Ok render children*/}
			{loadingState === LoadingState.LOADED && !isNoResult && children}

			{/*If it is loading, show loading spinner*/}
			{loadingState === LoadingState.LOADING && (
				<div className="blk-ac-empty-state">
					<LoadIndicator />
				</div>
			)}

			{/*in case of error show network error*/}
			{loadingState === LoadingState.ERROR && (
				<EmptyState {...networkErrorConfig} focused={focused} />
			)}

			{/*If there is no result (e.g. the item list is empty), show no result*/}
			{loadingState === LoadingState.LOADED && isNoResult && noResultConfig && (
				<EmptyState {...noResultConfig} focused={focused} />
			)}
		</>
	);
};

export default LoadAndEmptyStatesWrapper;
